/**
 * Perfume Match Quiz
 * iOS scroll-picker (JS-driven centering) → archetype selection → scored results
 */

(function () {
  'use strict';

  // ─── Archetype keyword map ────────────────────────────────────────────────
  var ARCHETYPES = {
    // Base / Lasting Impression
    Powerful:   { layer: 'base',   keywords: ['oud','amber','cedarwood','leather','sandalwood'] },
    Mysterious: { layer: 'base',   keywords: ['incense','patchouli','resins','oud','amber'] },
    Playful:    { layer: 'base',   keywords: ['vanilla','tonka','soft spices'] },
    Wise:       { layer: 'base',   keywords: ['vetiver','sandalwood','cedarwood','white musk'] },
    // Middle / Heart of The Scent
    Romantic:      { layer: 'middle', keywords: ['rose','jasmine','tuberose','white flowers'] },
    'Free-Spirited': { layer: 'middle', keywords: ['green','aquatic','herbal','fresh'] },
    Bold:          { layer: 'middle', keywords: ['leather','tobacco','smoke','pepper'] },
    Creative:      { layer: 'middle', keywords: ['iris','violet','neroli','floral'] },
    // Top / First Impression
    Bright:     { layer: 'top', keywords: ['bergamot','lemon','mandarin','apple'] },
    Dynamic:    { layer: 'top', keywords: ['grapefruit','pepper','ginger'] },
    Caring:     { layer: 'top', keywords: ['neroli','lavender','rose water'] },
    Easygoing:  { layer: 'top', keywords: ['green tea','pear','clean musk'] }
  };

  // ─── Helpers ──────────────────────────────────────────────────────────────
  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getCycleSize(scroll) {
    var value = parseInt(scroll.dataset.pmCycleSize || '0', 10);
    return Number.isFinite(value) ? value : 0;
  }

  function getItemHeight(scroll) {
    var value = parseFloat(scroll.dataset.pmItemHeight || '90');
    return Number.isFinite(value) ? value : 90;
  }

  function shiftItemToMiddleCycle(item, scroll) {
    var cycleSize = getCycleSize(scroll);
    if (!cycleSize) return item;

    var pickerEl = scroll.parentElement;
    var items = pickerEl.querySelectorAll('.ios-picker-item');
    var index = Array.prototype.indexOf.call(items, item);
    if (index === -1) return item;

    if (index < cycleSize) return items[index + cycleSize] || item;
    if (index >= cycleSize * 2) return items[index - cycleSize] || item;
    return item;
  }

  function normalizeInfiniteScroll(scroll) {
    var cycleSize = getCycleSize(scroll);
    if (!cycleSize) return;

    var cycleHeight = getItemHeight(scroll) * cycleSize;
    if (!cycleHeight) return;

    var min = cycleHeight * 0.5;
    var max = cycleHeight * 2.5;

    if (scroll.scrollTop < min) {
      scroll.scrollTop += cycleHeight;
    } else if (scroll.scrollTop > max) {
      scroll.scrollTop -= cycleHeight;
    }
  }

  // ─── Update the description panel below the picker ───────────────────────
  function updateDesc(item, pickerEl) {
    var col = pickerEl.parentElement; // .picker-col
    if (!col) return;
    var wrapper = col.querySelector('.picker-col__desc');
    var pEl    = wrapper && wrapper.querySelector('p');
    var srcDesc = item.querySelector('.desc');
    if (!wrapper || !pEl || !srcDesc) return;

    wrapper.classList.remove('is-visible');
    pEl.textContent = srcDesc.textContent.trim();
    requestAnimationFrame(function () {
      wrapper.classList.add('is-visible');
    });
  }

  // ─── Picker: select an item and smooth-scroll to center it ───────────────
  function selectItem(item, scroll, animateScroll) {
    var pickerEl = scroll.parentElement; // .ios-picker
    var items = pickerEl.querySelectorAll('.ios-picker-item');
    var middleItem = shiftItemToMiddleCycle(item, scroll);
    var shouldAnimate = Boolean(animateScroll);

    // Remove selected from all
    for (var i = 0; i < items.length; i++) {
      items[i].classList.remove('selected');
    }
    middleItem.classList.add('selected');

    // Update description panel below the picker
    updateDesc(middleItem, pickerEl);

    // Items are fixed height — center immediately
    requestAnimationFrame(function () {
      centerItem(middleItem, scroll, !shouldAnimate);
    });
  }

  function centerItem(item, scroll, instant) {
    var containerH = scroll.clientHeight;
    var itemCenter = item.offsetTop + item.offsetHeight / 2;
    var rawTarget = itemCenter - containerH / 2;
    var maxScroll = scroll.scrollHeight - containerH;
    var target = Math.max(0, Math.min(rawTarget, maxScroll));

    scroll.scrollTo({ top: target, behavior: instant ? 'auto' : 'smooth' });
  }

  // ─── Picker: find which item center is closest to scroll viewport center ─
  function findNearestItem(items, scroll) {
    var containerCenter = scroll.scrollTop + scroll.clientHeight / 2;
    var nearest = null;
    var minDist = Infinity;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var itemCenter = item.offsetTop + item.offsetHeight / 2;
      var dist = Math.abs(itemCenter - containerCenter);
      if (dist < minDist) {
        minDist = dist;
        nearest = item;
      }
    }
    return nearest;
  }

  // ─── Init a single picker ─────────────────────────────────────────────────
  function initPicker(pickerEl) {
    var scroll = pickerEl.querySelector('.picker-scroll');
    if (!scroll) return;

    var list = pickerEl.querySelector('.picker-list');
    if (!list) return;

    var seedItems = Array.prototype.slice.call(list.querySelectorAll('.ios-picker-item'));
    if (!seedItems.length) return;

    var selectedName = null;
    for (var s = 0; s < seedItems.length; s++) {
      if (seedItems[s].classList.contains('selected')) {
        selectedName = seedItems[s].dataset.name;
        break;
      }
    }

    var seedMarkup = seedItems.map(function (seedItem) {
      return seedItem.outerHTML.replace(/\sselected\b/g, '');
    }).join('');

    list.innerHTML = '<div class="spacer"></div>' + seedMarkup + seedMarkup + seedMarkup + '<div class="spacer"></div>';

    var items = pickerEl.querySelectorAll('.ios-picker-item');
    if (!items.length) return;

    var cycleSize = seedItems.length;
    var selectedBaseIndex = 0;

    if (selectedName) {
      for (var b = 0; b < seedItems.length; b++) {
        if (seedItems[b].dataset.name === selectedName) {
          selectedBaseIndex = b;
          break;
        }
      }
    }

    scroll.dataset.pmCycleSize = String(cycleSize);
    scroll.dataset.pmItemHeight = String(items[0].offsetHeight || 90);

    var middleSelectedIndex = cycleSize + selectedBaseIndex;
    if (items[middleSelectedIndex]) {
      items[middleSelectedIndex].classList.add('selected');
    }

    var scrollTimer = null;
    var isProgrammatic = false;

    // On user scroll end: snap to nearest
    scroll.addEventListener('scroll', function () {
      if (isProgrammatic) return;
      normalizeInfiniteScroll(scroll);
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var nearest = findNearestItem(items, scroll);
        if (!nearest) return;
        var current = pickerEl.querySelector('.ios-picker-item.selected');
        isProgrammatic = true;
        if (nearest !== current) {
          selectItem(nearest, scroll);
        } else {
          centerItem(nearest, scroll, true);
        }
        setTimeout(function () { isProgrammatic = false; }, 400);
      }, 160);
    });

    // Click on any item to select it
    for (var i = 0; i < items.length; i++) {
      (function (item) {
        item.addEventListener('click', function () {
          isProgrammatic = true;
          selectItem(item, scroll, true);
          setTimeout(function () { isProgrammatic = false; }, 700);
        });
      })(items[i]);
    }

    // Initialize: center the pre-selected item (set in HTML)
    var preSelected = pickerEl.querySelector('.ios-picker-item.selected') || items[cycleSize] || items[0];
    if (!preSelected.classList.contains('selected')) {
      preSelected.classList.add('selected');
    }

    // Populate description panel below picker
    var col = pickerEl.parentElement;
    if (col) {
      var wrapper = col.querySelector('.picker-col__desc');
      var pEl = wrapper && wrapper.querySelector('p');
      var srcDesc = preSelected.querySelector('.desc');
      if (wrapper && pEl && srcDesc) {
        pEl.textContent = srcDesc.textContent.trim();
        setTimeout(function () { wrapper.classList.add('is-visible'); }, 300);
      }
    }

    // Use setTimeout so DOM is fully rendered before we measure offsetTop
    isProgrammatic = true;
    setTimeout(function () {
      centerItem(preSelected, scroll, true);
      setTimeout(function () { isProgrammatic = false; }, 200);
    }, 50);
  }

  // ─── Get the selected archetype from a picker ─────────────────────────────
  function getSelectedArchetype(pickerEl) {
    var selected = pickerEl.querySelector('.ios-picker-item.selected');
    if (!selected) return null;
    var name = selected.dataset.name;
    var def = ARCHETYPES[name];
    if (!def) return null;
    return { name: name, layer: def.layer, keywords: def.keywords };
  }

  // ─── Scoring ───────────────────────────────────────────────────────────────
  function scoreProduct(product, selfArch, soulArch, egoArch) {
    var score = 0;
    var base   = (product.baseNotes   || '').toLowerCase();
    var middle = (product.middleNotes || '').toLowerCase();
    var top    = (product.topNotes    || '').toLowerCase();

    if (selfArch) {
      selfArch.keywords.forEach(function (kw) {
        if (base.indexOf(kw) !== -1) score += 2;
      });
    }
    if (soulArch) {
      soulArch.keywords.forEach(function (kw) {
        if (middle.indexOf(kw) !== -1) score += 2;
      });
    }
    if (egoArch) {
      egoArch.keywords.forEach(function (kw) {
        if (top.indexOf(kw) !== -1) score += 1;
      });
    }
    return score;
  }

  // ─── Build notes preview string ───────────────────────────────────────────
  function buildNotes(product) {
    var parts = [];
    if (product.topNotes)    parts.push(product.topNotes);
    if (product.middleNotes) parts.push(product.middleNotes);
    if (!parts.length && product.baseNotes) parts.push(product.baseNotes);
    var text = parts.join(' · ');
    return text.length > 90 ? text.slice(0, 89) + '…' : text;
  }

  // ─── Build a product card HTML string ────────────────────────────────────
  function buildCard(product, isBestMatch) {
    var title  = escapeHtml(product.title);
    var price  = escapeHtml(product.price);
    var url    = escapeHtml(product.url);
    var notes  = escapeHtml(buildNotes(product));
    var varId  = product.variantId;
    var single = product.hasOnlyDefaultVariant;

    var imageHtml = product.image
      ? '<img src="' + escapeHtml(product.image) + '" alt="' + title + '" loading="lazy">'
      : '<div class="pm-card__placeholder"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><path d="M12 2C8.5 2 6 4.5 6 7c0 2 1 3.5 2.5 4.5V20h7V11.5C17 10.5 18 9 18 7c0-2.5-2.5-5-6-5z"/></svg></div>';

    var actionHtml = single
      ? '<button class="pm-card__atc" data-variant="' + varId + '">Add to Cart</button>'
      : '<a href="' + url + '" class="pm-card__select">Select Options</a>';

    var badgeHtml = isBestMatch ? '<div class="pm-card__badge">Best Match</div>' : '';
    var sku       = escapeHtml(product.sku || '');

    return '<div class="pm-card' + (isBestMatch ? ' pm-card--active' : '') + '">'
      + '<a href="' + url + '" class="pm-card__image">' + badgeHtml + imageHtml + '</a>'
      + '<div class="pm-card__body">'
      + '<h3 class="pm-card__title">' + title + '</h3>'
      + '<p class="pm-card__price">' + price + '</p>'
      + (sku ? '<p class="pm-card__sku">SKU: ' + sku + '</p>' : '')
      + (notes ? '<p class="pm-card__notes">' + notes + '</p>' : '')
      + actionHtml
      + '</div>'
      + '</div>';
  }

  // ─── Add to Cart ──────────────────────────────────────────────────────────
  function addToCart(variantId, btn) {
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
    .then(function (res) {
      if (res.ok) {
        btn.textContent = 'Added!';
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          });
        setTimeout(function () {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        }, 2200);
      } else {
        return res.json().then(function (err) {
          btn.textContent = (err && err.description) ? err.description : 'Try again';
          btn.disabled = false;
        });
      }
    })
    .catch(function () {
      btn.textContent = 'Try again';
      btn.disabled = false;
    });
  }

  // ─── Show results ─────────────────────────────────────────────────────────
  function showResults(products, selfArch, soulArch, egoArch) {
    var quiz    = document.getElementById('pm-quiz');
    var results = document.getElementById('pm-results');
    var grid    = document.getElementById('pm-results-grid');
    var summary = document.getElementById('pm-archetype-summary');
    if (!results || !grid || !summary) return;

    // Score and sort
    var scored = products.map(function (p) {
      return { product: p, score: scoreProduct(p, selfArch, soulArch, egoArch) };
    }).sort(function (a, b) { return b.score - a.score; });

    var matched    = scored.filter(function (x) { return x.score > 0; });
    var toShow     = (matched.length > 0 ? matched : scored).slice(0, 15);
    var isFallback = matched.length === 0;

    // Archetype summary
    var names = [selfArch, soulArch, egoArch]
      .filter(Boolean)
      .map(function (a) { return '<strong>' + escapeHtml(a.name) + '</strong>'; })
      .join(' &middot; ');
    summary.innerHTML = names + (isFallback ? ' &mdash; No exact matches, showing closest picks.' : '');

    // Build slider
    if (toShow.length) {
      grid.innerHTML =
        '<div class="pm-slider">'
        + '<button class="pm-slider__arrow pm-slider__arrow--prev" aria-label="Previous perfume">&#8249;</button>'
        + '<div class="pm-slider__viewport">'
        + '<div class="pm-slider__track">'
        + toShow.map(function (x, i) { return buildCard(x.product, i === 0); }).join('')
        + '</div>'
        + '</div>'
        + '<button class="pm-slider__arrow pm-slider__arrow--next" aria-label="Next perfume">&#8250;</button>'
        + '</div>';
    } else {
      grid.innerHTML = '<div class="pm-no-results"><strong>No products found.</strong>Make sure products have base, middle, and top note metafields.</div>';
    }

    // Wire ATC buttons
    grid.querySelectorAll('.pm-card__atc').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCart(btn.dataset.variant, btn);
      });
    });

    // Init slider
    initSlider(grid);

    // Show results, hide quiz
    if (quiz) quiz.style.display = 'none';
    results.removeAttribute('hidden');
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ─── Slider logic ─────────────────────────────────────────────────────────
  function initSlider(container) {
    var slider   = container.querySelector('.pm-slider');
    if (!slider) return;

    var viewport = slider.querySelector('.pm-slider__viewport');
    var track    = slider.querySelector('.pm-slider__track');
    var prevBtn  = slider.querySelector('.pm-slider__arrow--prev');
    var nextBtn  = slider.querySelector('.pm-slider__arrow--next');
    if (!viewport || !track || !prevBtn || !nextBtn) return;

    var currentIndex = 0;

    function getCards() {
      return track.querySelectorAll('.pm-card');
    }

    function scrollToIndex(index, animate) {
      var cards = getCards();
      var total = cards.length;
      index = Math.max(0, Math.min(index, total - 1));
      currentIndex = index;

      var card        = cards[index];
      var cardLeft    = card.offsetLeft;
      var cardWidth   = card.offsetWidth;
      var viewW       = viewport.offsetWidth;
      var target      = cardLeft - (viewW - cardWidth) / 2;

      viewport.scrollTo({ left: target, behavior: animate === false ? 'auto' : 'smooth' });

      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex === total - 1;

      // Highlight active card
      for (var i = 0; i < cards.length; i++) {
        cards[i].classList.toggle('pm-card--active', i === currentIndex);
      }
    }

    prevBtn.addEventListener('click', function () { scrollToIndex(currentIndex - 1); });
    nextBtn.addEventListener('click', function () { scrollToIndex(currentIndex + 1); });

    // Snap after manual scroll
    var scrollTimer;
    viewport.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var cards      = getCards();
        var vpCenter   = viewport.scrollLeft + viewport.offsetWidth / 2;
        var nearest    = 0;
        var minDist    = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var cardCenter = cards[i].offsetLeft + cards[i].offsetWidth / 2;
          var dist = Math.abs(cardCenter - vpCenter);
          if (dist < minDist) { minDist = dist; nearest = i; }
        }
        if (nearest !== currentIndex) scrollToIndex(nearest);
      }, 120);
    });

    // Center best-match card on load (index 0)
    setTimeout(function () { scrollToIndex(0, false); }, 80);
  }

  // ─── Main init ────────────────────────────────────────────────────────────
  function init() {
    var pickerSelf = document.getElementById('pickerSelf');
    var pickerSoul = document.getElementById('pickerSoul');
    var pickerEgo  = document.getElementById('pickerEgo');
    var findBtn    = document.getElementById('pm-find-btn');
    var restartBtn = document.getElementById('pm-restart');
    var dataEl     = document.getElementById('pm-products-data');

    if (!pickerSelf || !pickerSoul || !pickerEgo) return;

    // Parse product data
    var products = [];
    if (dataEl) {
      try { products = JSON.parse(dataEl.textContent); }
      catch (e) { console.warn('[PerfumeMatch] product data parse error', e); }
    }

    // Init pickers
    initPicker(pickerSelf);
    initPicker(pickerSoul);
    initPicker(pickerEgo);

    // Remove loader once pickers are positioned
    var loader = document.getElementById('pm-loader');
    var page   = document.querySelector('.pm-page');
    if (page) page.classList.add('pm-ready');
    if (loader) {
      loader.classList.add('pm-loader--hidden');
      loader.addEventListener('transitionend', function () { loader.remove(); }, { once: true });
    }

    // Find My Scent
    if (findBtn) {
      findBtn.addEventListener('click', function () {
        var selfArch = getSelectedArchetype(pickerSelf);
        var soulArch = getSelectedArchetype(pickerSoul);
        var egoArch  = getSelectedArchetype(pickerEgo);
        showResults(products, selfArch, soulArch, egoArch);
      });
    }

    // Restart
    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        var quiz    = document.getElementById('pm-quiz');
        var results = document.getElementById('pm-results');
        if (results) results.setAttribute('hidden', '');
        if (quiz) {
          quiz.style.display = '';
          quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
